const hoverToTouch = {
	el: {
		body: $('body')
	},
	init() {
		this.el.body.on('touchstart', () => {})
	}
}

hoverToTouch.init()